import { useTheme } from '@emotion/react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary, Box,
} from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useRef, useState } from 'react'
import CustomModal from '../../UI/CustomModal'
import { StyledButton } from '../../UI/StyledButton'
import { canApproveEsitoADV } from '../../services/canApproveEsitoADV'
import { saveApprovazioneAdv } from '../../services/saveApprovazioneADV'
import RenderComponente from './sezioni/RenderComponente'
import Supporto from './sezioni/Supporto'
import { StatiPratica } from 'enums/stati-pratica'
import { isValidUser } from 'OnlyWithFunctions'
import { Roles } from "enums/roles"
import { listaStatiRichiestaSupportoSezioneBlu } from "enums/constants-richieste-supporto"

export function SezioneBlu({
  esitoAdv,
  tipoInserimento,
  statoPratica,
  idPratica,
  abilitaChiuso,
  refecthPratica,
  handleReloadDettaglio,
  assegnatario,
}) {
  const theme = useTheme()

  const [rootComponent, setRootComponent] = useState(esitoAdv)
  const [expanded, setExpanded] = useState(false)
  const [open, setOpen] = useState(false)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [saveRequired, setSaveRequired] = useState(false)
  const [infoMessage, setInfoMessage] = useState('')
  const [showSupporto, setShowSupporto] = useState(false)
  const [rispostaSupporto, setRispostaSupporto] = useState(false)
  const disableChoice = statoPratica === 'Chiusa'
  const [canApprove, setCanApprove] = useState(false)
  const showButton = !disableChoice

  const hasFetched = useRef(false)
  const [openModal, setOpenModal] = useState(false)
  const [selezioneCambiata, setSelezioneCambiata] = useState(false)
  const [componenteSelezione, setComponenteSelezione] = useState(null)
  const [selezionato, setSelezionato] = useState('NESSUNA')


  useEffect(() => {
    if (idPratica && !hasFetched.current) {
      hasFetched.current = true // Imposta il flag per evitare richiami futuri

    }
  }, [idPratica])



  useEffect(() => {
    if (selezioneCambiata) {
      let qualcosaSelezionato = false
      for (let child of componenteSelezione.children) {
        if (child.label === 'SI' && child.isSelected) {
          setSelezionato('SI')
          qualcosaSelezionato = true
        }
        if (child.label === 'NO' && child.isSelected) {
          setSelezionato('NO')
          qualcosaSelezionato = true
        }

      }
      if (!qualcosaSelezionato) {
        setSelezionato('NESSUNA')
      }
      setSelezioneCambiata(false)
    }

  }, [selezioneCambiata])

  const updateComponenteSelection = (componente, isSelected, value) => {
    const updateRecursively = (comp) => {
      if (comp === componente) {

        if (comp.tipoComponente === 'TEXTFIELD') {
          comp.value = value
        }
        if (comp.label === 'SI' || comp.label === 'NO')
          setSelezioneCambiata(true)
        comp.isSelected = isSelected

        setSaveRequired(true)

      }
      if (comp.children) {
        comp.children.forEach(child => updateRecursively(child))
      }


    }
    const updatedRoot = { ...rootComponent }
    updateRecursively(updatedRoot)
    setRootComponent(updatedRoot)
  }

  useEffect(() => {
    if (esitoAdv) {
      setRootComponent(esitoAdv)
      canApproveEsitoADV(idPratica)
        .then(response => setCanApprove(response))
        .catch(error => {
          console.error('Errore nella verifica canApprove:', error)
          setCanApprove(false)
        })
      const findComponent = (component) => {
        if (component.label === 'Approvazione a') {
          return component
        }
        if (component.children) {
          for (let child of component.children) {
            const found = findComponent(child)
            if (found) return found
          }
        }
        return null
      }

      // Esegui la ricerca
      const targetComponent = findComponent(esitoAdv)
      if (targetComponent) {
        setComponenteSelezione(targetComponent.children[0])
      }
    }

  }, [esitoAdv, canApprove])
  const handleOpenModal = () => {
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }
  const handleSalvaEsito = () => {

    setOpen(true)
    setLoading(true)
    setInfoMessage('Attendere....salvataggio in corso')
    saveApprovazioneAdv(rootComponent, idPratica).then(response => {
      setSaveRequired(false)
      setInfoMessage(response.data.message)
      setLoading(false)
      setError(false)
      setTimeout(function () {
        setOpen(false)
        setInfoMessage('')
        handleCloseModal()
        handleReloadDettaglio()
      }, 3000)
    })
      .catch(error => {
        setLoading(false)
        setInfoMessage(error.response.data.message)
        setError(true)
        setTimeout(function () {
          setOpen(false)
          setInfoMessage('')
          setError(false)
        }, 3000)
      })
    handleCloseModal()


  }


  const handleShowSupporto = (rispostaSupporto) => {
    setRispostaSupporto(rispostaSupporto)
    setShowSupporto(prevState => !prevState)
  }

  if (!rootComponent) {
    return <div>Caricamento...</div>
  }

  return (
    <div>
      <CustomModal
        open={open}
        loading={loading}
        error={error}
        message={infoMessage}
      />
      <Accordion
        elevation={0}
        disableGutters square={true}
        expanded={expanded}
        onChange={() => setExpanded(prevState => !prevState)}
      >
        <AccordionSummary
          sx={{
            backgroundColor: theme.palette.blue.dark,
            width: '100%',
            color: 'white',
          }}

          expandIcon={<ArrowDropDownIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          {rootComponent.label}
        </AccordionSummary>
        <AccordionDetails
          sx={{
            backgroundColor: theme.palette.blue.light,
            width: '100%',
            alignItems: 'center',
          }}
        >
          {expanded && rootComponent.children && rootComponent.children.map((child, index) => (
            <RenderComponente
              key={index}
              componente={child}
              updateSelection={updateComponenteSelection}
              marginLevel={1}
              ndRequired={false}
              disable={!canApprove}
            />
          ))}
          {/*<DocOpzionali ></DocOpzionali>
*/}
          <AccordionActions sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            {(canApprove && listaStatiRichiestaSupportoSezioneBlu.includes(statoPratica)) && (
              <StyledButton
                onClick={() => handleShowSupporto(false)}
                sx={{ borderRadius: '5px 0px 0px 0px', mt: 5 }}
              >
                Richiesta Supporto
              </StyledButton>)}


            <Box sx={{ flexGrow: 1 }} />

            {(canApprove && statoPratica === StatiPratica.DA_APPROVARE.stato) && (

              <StyledButton
                onClick={handleOpenModal}
                sx={{ borderRadius: '5px 0px 0px 0px', mt: 5 }}
                disabled={!saveRequired}
              >
                Salva
              </StyledButton>
            )}
            <Dialog
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{'Conferma chiusura pratica'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {selezionato === 'NESSUNA' && 'Attenzione: selezionare SI o NO per approvare Esito Adeguata Verifica.'}
                  {selezionato === 'SI' && 'Confermando, l\'esito della Adeguata Verifica sarà approvato, e la pratica passerà nello stato "Chiusa" e questa azione non può essere annullata.'}
                  {selezionato === 'NO' && 'Confermando, l\'esito della Adeguata Verifica non sarà approvato, e la pratica tornerà nello stato "Info Complete", per essere nuovamente lavorato dall\'operatore. Questa azione non può essere annullata.'}

                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {selezionato !== 'NESSUNA' && <Button onClick={handleSalvaEsito} color="primary" autoFocus>
                  Conferma
                </Button>}
                <Button onClick={handleCloseModal} color="primary">
                  Annulla
                </Button>

              </DialogActions>
            </Dialog>


          </AccordionActions>

        </AccordionDetails>
      </Accordion>
      {(showSupporto &&
        (statoPratica === StatiPratica.DA_APPROVARE.stato)) &&
        <Supporto
          idPratica={idPratica}
          modalOpen={showSupporto}
          handleMod={handleShowSupporto}
          {...{ rispostaSupporto, assegnatario }}
        />}
    </div>
  )
}
